import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function PrivacyPage() {
  const { t } = useLanguage();
  return (
    <div className="px-6 md:px-12 max-w-4xl mx-auto py-12 md:py-20" data-testid="privacy-page">
      <h1 className="text-4xl font-bold text-white font-['Outfit'] tracking-tight mb-8">{t('footer.privacy')}</h1>
      <div className="bg-[#0A0A0A] border border-white/5 rounded-sm p-8 md:p-12 space-y-6 text-zinc-400 text-sm leading-relaxed">
        <p className="text-zinc-500 text-xs">Last updated: February 2026</p>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">1. Data Controller</h2>
          <p>The data controller for the processing of personal data on XDomainX.com is <strong className="text-white">Liber nostra d.o.o.</strong> We are committed to protecting your privacy and handling your personal data responsibly.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">2. Information We Collect</h2>
          <p>We collect information you provide directly: name, email address, phone number, company name, and payment information. We also collect usage data automatically: IP address, browser type, pages visited, and interaction data through cookies and similar technologies.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">3. How We Use Your Data</h2>
          <p>Your data is used to: provide and maintain our services, process transactions and payments, send notifications about your account and transactions, improve our platform and user experience, comply with legal obligations, and communicate about updates, promotions, and domain-related opportunities.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">4. Data Sharing</h2>
          <p>We do not sell your personal data. We may share data with: payment processors (myPOS, Stripe) to process transactions, authentication providers (Auth0) for secure login, domain registrars for transfer verification, and law enforcement when required by law.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">5. Data Security</h2>
          <p>We implement industry-standard security measures including encryption (TLS/SSL), secure password hashing (bcrypt), JWT token-based authentication, and regular security audits. However, no method of transmission over the Internet is 100% secure.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">6. Your Rights (GDPR)</h2>
          <p>Under GDPR, you have the right to: access your personal data, rectify inaccurate data, erase your data ("right to be forgotten"), restrict processing, data portability, and object to processing. To exercise these rights, contact us at info@xdomainx.com.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">7. Cookies</h2>
          <p>We use essential cookies for authentication and session management, and optional cookies for analytics and preferences (language selection). You can manage cookie preferences through your browser settings.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">8. Data Retention</h2>
          <p>We retain personal data for as long as your account is active or as needed to provide services. Transaction records are kept for 7 years for legal compliance. You may request deletion of your account and associated data at any time.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">9. Contact</h2>
          <p>For privacy-related inquiries:<br/>
          <strong className="text-white">Liber nostra d.o.o.</strong><br/>
          Email: info@xdomainx.com<br/>
          You also have the right to lodge a complaint with a supervisory authority.</p>
        </section>
      </div>
    </div>
  );
}
